var _effectorFileName = "/builds/gmini/front-ui-kit/src/Select/components/Input/Input.styled.ts";
import styled, { css } from 'styled-components';
import { HighlightOff as HighlightOffInit, ArrowDown as ArrowDownInit } from '../../../icons';
export const RenderSelectInputValueWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  background: ${props => props.colorScheme === 'white' ? '#fff' : '#f5f5f7'};
  ${props => props.disabled && (props.colorScheme === 'white' ? css`
          background: rgba(255, 255, 255, 0.5);
        ` : css`
          background: rgba(244, 244, 248, 0.5);
        `)}

  ${props => props.lock && css`
      pointer-events: none;
    `}
`;
export const InputSelectWrapper = styled.div`
  width: 100%;
  position: relative;
  ${props => props.disabled && css`
      pointer-events: none;
    `}

  ${props => props.disabled && props.additionalStyles}
`;
export const SelectInputStyled = styled.input`
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background: ${props => props.colorScheme === 'white' ? '#fff' : '#F4F4F8'};
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.1px;
  outline: none;
  padding: 9.5px 55px 9.5px 12px;
  transition: background-color 0.2s ease-out, box-shadow 0.2s ease-out,
    border-color 0.2s ease-out;
  border: 1px solid transparent;
  color: #353b60;
  font-family: Roboto, sans-serif;
  ${props => !props.disabledSelect && props.error && css`
      border: 1px solid #d9575e;
    `}
  ${props => props.disabledSelect && css`
      pointer-events: none;
      color: rgba(53, 59, 96, 0.2);
    `}
    ${props => props.disabledSelect && (props.colorScheme === 'white' ? css`
          background: rgba(255, 255, 255, 0.5);
        ` : css`
          background: rgba(244, 244, 248, 0.5);
        `)}
  ${props => props.existIcon && !props.focused && css`
      padding-left: 40px;
    `}

  &::placeholder {
    color: ${props => props.disabledSelect ? 'rgba(53, 59, 96, 0.2)' : 'rgba(53, 59, 96, 0.4)'};
    font-weight: 500;
    user-select: none;
  }

  &:hover {
    border: 1px solid #c5c6d1;
  }

  ${props => props.lock && css`
      pointer-events: none;
    `}

  &:focus {
    background: #fff;
    box-shadow: 0px 5px 10px rgba(53, 60, 96, 0.1);
    border: 1px solid #4c5ecf;
  }

  ${props => props.inputStyled}
`;
export const RenderSelectInputValue = styled.div`
  position: absolute;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: ${props => props.disabled ? 'rgba(53, 59, 96, 0.2)' : '#353b60'};
  letter-spacing: 0.1px;
  padding: 9.5px 55px 9.5px 12px;
  height: 100%;
  white-space: nowrap;
  width: calc(100% - 55px);
  top: 1px;
  left: 2px;
  overflow: hidden;
  background: ${props => props.colorScheme === 'white' ? '#fff' : '#F5F5F7'};
  ${props => props.disabled && (props.colorScheme === 'white' ? css`
          background: rgba(255, 255, 255, 0.5);
        ` : css`
          background: rgba(244, 244, 248, 0.5);
        `)}

  ${RenderSelectInputValueWrapper} {
    ${props => props.disabled && css`
        background: #fff;
      `}
  }
`;
export const ArrowDown = styled(ArrowDownInit)`
  ${props => props.turned && css`
      transform: rotate(180deg);
    `}
`;
export const HighlightOff = styled(HighlightOffInit)`
  path:first-child {
    transition: ease-out 0.2s;
    fill: rgba(53, 59, 96, 0.25);
  }

  &:hover {
    path:first-child {
      ${props => !props.disabled && css`
          fill: #353b60;
        `}
    }
  }

  &:focus {
    path:first-child {
      ${props => !props.disabled && css`
          fill: #00003d;
        `}
    }
  }
`;
export const LeftIconWrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 12px;
  opacity: ${props => props.disabled ? 0.9 : 1};
`;
export const SelectInputIconWrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 9px;
  top: 50%;
  transform: translateY(-50%);
`;
export const RightIconWrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 8px;
  gap: 8px;
  top: 50%;
  transform: translateY(-50%);
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  opacity: ${props => props.disabled && '0.2'};
`;